import fetch from '../utils/fetch';

// 获取手机验证码
export function getVerifyCode(params) {
    const hostname = window.location.hostname;
    const isDebugMode = hostname === 'qr.yidiantechnology.com' || hostname.startsWith('192.168') || hostname.startsWith('localhost');
    const debugQuery = isDebugMode ? '&debug=1' : '';

    return fetch({
        url: `app/member/getVerifyCode?type=3${debugQuery}`,
        method: 'POST',
        data: params
    })
}

// 获取邮箱验证码
export function getEmailVerifyCode(params) {
    return fetch({
        url: 'app/member/getEmailVerifyCode?type=3',
        method: 'GET',
        params: params
    })
}

// 登录或注册
export function loginOrRegister(params) {
    return fetch({
        url: 'app/member/loginOrRegister',
        method: 'POST',
        data: params
    })
}

// 直接弹宝页-直接弹宝
export function releasePowerBank(params) {
    return fetch({
        url: '/webapp/releasePB',
        method: 'POST',
        data: params
    })
}

export function quickLogin(data) {
    return fetch({
        url: '/webapp/quickLogin',
        method: 'POST',
        data: data
    })
}
